module.exports = __webpack_public_path__ + "img/battery.f8926b3b.svg";